module.exports = __webpack_public_path__ + "static/media/no-candidate-375.d6764baf.webp";